import './style.css';

import React, { useEffect, useState } from "react";

import { Controller, useForm } from 'react-hook-form';
import { Divider, Input, Rate, Collapse, notification, Skeleton, Spin } from 'antd';
import axiosCall from '../../utils/axiosCall';
import NumberFormat from 'react-number-format';
import { Link, useSearchParams } from 'react-router-dom';
import { connect } from "react-redux";

import Nav from '../../utils/nav';
import Footer from '../../utils/footer';

import likeEmoji from '../../assets/images/icons/heart.svg';
import likeFilledEmoji from '../../assets/images/icons/filled_heart.svg';

import products1 from '../../assets/images/content/products1.webp';
import products2 from '../../assets/images/content/products2.webp';
import products3 from '../../assets/images/content/products3.webp';
import products4 from '../../assets/images/content/products4.webp';
import products5 from '../../assets/images/content/products5.webp';
import products6 from '../../assets/images/content/products6.webp';
import products7 from '../../assets/images/content/products7.webp';


const Shop = props => {

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            description:
                message,
        });
    };

    const [searchParams, setSearchParams] = useSearchParams();
    const [productData, setProductData] = useState({});
    const [userId] = useState(props.auth.isAuthenticated ? props.auth.userDetails.id : null);
    const [productInWishList, setProductInWishList] = useState(false);
    const [productInCart, setProductInCart] = useState(false);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [spinnerMessage, setSpinnerMessage] = useState('');
    const [addWishList, setAddWishList] = useState(false);
    const [trendingProducts, setTrendingProducts] = useState([]);
    const [fetchingProducts, setFetchingProducts] = useState(true);
    const [currentColor, setCurrentColor] = useState(false);
    const [spinning, setSpinning] = useState(false);
    const [imageBox, setImageBox] = useState([
        'https://vo3designs.s3.amazonaws.com/Kids%27%20Bed%201',
        'https://vo3designs.s3.amazonaws.com/Kids%27%20Bed%202',
        'https://vo3designs.s3.amazonaws.com/Mrs%20Oyin%201']);
    const [currentImage, setCurrentImage] = useState(0);


    let skeleton = [];
    for (let i = 0; i < 6; i++) {
        skeleton.push(<Skeleton active />)
    }

    const { handleSubmit, control } = useForm({});
    const { Panel } = Collapse;
    const text = `The middle child of our lineup of L sectionals is hardly one to be ignored. It’s
                                    well-rounded and perfect for medium-sized living rooms.`

    useEffect(() => {
        let productName = searchParams.get('productId');
        axiosCall(`/products/productById/${productName}`)
            .then(data => {
                if (data.data.statusMessage === "success") {
                    setFetchingProducts(false);
                    setProductData(data.data.message);
                    let extraImageBox = [data.data.message.productImage];
                    for(let imageList of data.data.message.productImage) {
                        extraImageBox.push(imageList);
                    }
                    setImageBox(extraImageBox)
                } else {
                    openNotificationWithIcon('error', data.data.summary);
                }
            })
            .catch(err => {
                openNotificationWithIcon('error', 'An error occurred while loading data. Please reload page to try again')
            })
        axiosCall(`/products/trending`)
            .then(data => {
                if (data.data.statusMessage === "success") {
                    setTrendingProducts(data.data.message);
                } else {
                    openNotificationWithIcon('error', data.data.summary);
                }
            })
            .catch(err => {
                openNotificationWithIcon('error', 'An error occurred while loading data. Please reload page to try again')
            })
    }, [])

    const selectItemColor = e => {
        setCurrentColor(e)
    }

    const addMerchToCart = product => {
        setSpinning(true)
        axiosCall.post('/products/cart/new', {
            userId: props.auth.userDetails.id,
            productId: product.id,
            cartId: localStorage.getItem('cart-token')
        })
            .then(cartResponse => {
                if (cartResponse.data.statusMessage === "success") {
                    localStorage.setItem('cart-token', cartResponse.data.message);
                    setSpinning(false);
                    openNotificationWithIcon('success', 'Product added to cart successfully');
                } else {
                    setSpinning(false);
                    openNotificationWithIcon('error', 'An error occurred while adding product to cart. Please try again');
                }
            })
            .catch(err => {
                setSpinning(false);
                openNotificationWithIcon('error', 'An error occurred while adding product to cart. Please try again');
            })
    }


    const addToWishList = e => {
        e.preventDefault();
        // let currentText = document.querySelector('form#addWishList button').innerHTML;
        // document.querySelector('form#addWishList button').setAttribute('disabled', true);
        setAddWishList(true)
        setSpinning(true);
        setSpinnerMessage('Please wait...');
        axiosCall.post('/users/saved-items', {
            productId: productData.id,
            UserId: userId,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(data => {
                setAddWishList(false);
                if (data.data.summary === "Product saved in wishlist") {
                    setProductInWishList(true);
                    setSpinning(false);
                    openNotificationWithIcon('success', data.data.summary);
                } else if (data.data.summary === "Product removed from wishlist") {
                    setProductInWishList(false);
                    setSpinning(false);
                    openNotificationWithIcon('success', data.data.summary);
                }
            })
            .catch(err => {
                setAddWishList(false)
            })
    }

    const nextProductImage = () => {
        console.log('next')
        console.log(currentImage)
        if (currentImage !== (imageBox.length - 1)) {
            console.log(currentImage + 1)
            setCurrentImage(currentImage + 1);
        }
    }

    const previousProductImage = () => {
        console.log('previous')
        console.log(currentImage)
        if (currentImage !== 0) {
            console.log(currentImage - 1)
            setCurrentImage(currentImage - 1);
        }
    }

    return (
        <div>
            <Spin spinning={spinning}>
                <Nav border={true} />
                <div className="contain single_product_detail">
                    <div className="grid_2">
                        <div className="product_detail_image"
                        >
                            {
                                !fetchingProducts ?
                                    <div>
                                        {
                                            imageBox.length > 1 ?
                                                <div className="product-carousel-cover">
                                                    <img src={imageBox[currentImage]} className="product_detail_main" alt={productData?.productName} />
                                                    <div
                                                        onClick={() => nextProductImage()}
                                                        className="forward icon-block">
                                                        <ion-icon name="chevron-forward-outline"></ion-icon>
                                                    </div>
                                                    <div
                                                        onClick={() => previousProductImage()}
                                                        className="backward icon-block">
                                                        <ion-icon name="chevron-back-outline"></ion-icon>
                                                    </div>
                                                </div>
                                                :
                                                <img src={imageBox[0]} className="product_detail_main" alt={productData?.productName} />
                                        }
                                    </div>
                                    : ''
                            }
                        </div>
                        <div className="product_detail_info">
                            <div className="grid_flex">
                                <div>
                                    <h2>{!fetchingProducts ? productData?.productName : ''}</h2>
                                    {/* <p className="amount"><span className="currency">NGN</span> 99,999.00</p> */}
                                    <p className="amount"><span className="currency">NGN</span>
                                        <NumberFormat
                                            className="new_product_amount"
                                            value={(+productData.price).toFixed(2)} displayType={'text'} thousandSeparator={true} />
                                    </p>
                                </div>
                                <div>
                                    {
                                        props.auth.isAuthenticated ?
                                            <form onSubmit={addToWishList} id="addWishList">
                                                <button className="gray_border"
                                                >{productInWishList ?
                                                    // 'Remove from WishList'
                                                    <img src={likeFilledEmoji}
                                                        className="likeEmoji"
                                                        alt="like emoji" />
                                                    :
                                                    // 'Add to WishList'
                                                    <img src={likeEmoji}
                                                        className="likeEmoji"
                                                        alt="like emoji" />
                                                    }
                                                </button>
                                            </form>
                                            :
                                            <div>
                                                <Link className="gray_border" to="/signin">
                                                    <img src={likeEmoji}
                                                        className="likeEmoji"
                                                        alt="like emoji" />
                                                </Link>
                                            </div>
                                    }
                                </div>
                            </div>
                            <p className="product_detail"><h2>{!fetchingProducts ? productData?.description : ''}</h2></p>
                            <div className="product-detail-desc">
                                <div className="inline_block">
                                    <p>Color:</p>
                                    <div className="inline_display">
                                        <div>
                                            <div
                                                onClick={() => selectItemColor('#E1E0E5')}
                                                className={`color_bar ${currentColor === '#E1E0E5' ? 'selectedColor' : ''}`}>
                                                <div
                                                    style={{ background: '#E1E0E5', height: 'inherit', width: 'inherit' }}>
                                                    <ion-icon name="checkmark-outline"></ion-icon>
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => selectItemColor('#E9672B')}
                                                className={`color_bar ${currentColor === '#E9672B' ? 'selectedColor' : ''}`}>
                                                <div style={{ background: '#E9672B', height: 'inherit', width: 'inherit' }}>
                                                    <ion-icon name="checkmark-outline"></ion-icon>
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => selectItemColor('#000')}
                                                className={`color_bar ${currentColor === '#000' ? 'selectedColor' : ''}`}>
                                                <div style={{ background: '#000', height: 'inherit', width: 'inherit' }}>
                                                    <ion-icon name="checkmark-outline"></ion-icon>
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => selectItemColor('#FADB14')}
                                                className={`color_bar ${currentColor === '#FADB14' ? 'selectedColor' : ''}`}>
                                                <div style={{ background: '#FADB14', height: 'inherit', width: 'inherit' }}>
                                                    <ion-icon name="checkmark-outline"></ion-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="inline_block">
                                    <p>Dimension:</p>
                                    <div className="inline_display">
                                        <div>
                                            <div className="dimension_box">{!fetchingProducts ? productData?.dimension : ''}ft</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'block', marginTop: '5%' }}></div>
                            <button
                                onClick={() => addMerchToCart(productData.id)}
                                className="btn-accent full_width">Add to Cart</button>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="portfolio_products products contain mt_5">
                        <div>
                            <h3>Other products to checkout</h3>
                        </div>
                        {
                            !fetchingProducts ?
                                trendingProducts.length > 0 ?
                                    <div className="portfolio_products_grid">
                                        {
                                            trendingProducts.map((products, index) => (
                                                <div key={index}>
                                                    <Link to={`/product_detail?productId=${products.id}&product=${products.productName}`}>
                                                        <div>
                                                            <div className="product-images">
                                                                <img src={products.productImage} alt="extra_1" />
                                                            </div>
                                                            <h4 className="furniture_name">{products.productName}</h4>
                                                            <p className="furniture_amount"><span>NGN</span>
                                                                <NumberFormat
                                                                    className="new_product_amount"
                                                                    value={(+products.price).toFixed(2)} displayType={'text'} thousandSeparator={true} />
                                                            </p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    :
                                    <div className="grid_6">
                                        {skeleton.map((placeHolder, index) => (
                                            <div className="item" key={index}>
                                                {placeHolder}
                                            </div>
                                        ))}
                                    </div>
                                :
                                <div className="grid_6">
                                    {skeleton.map((placeHolder, index) => (
                                        <div className="item" key={index}>
                                            {placeHolder}
                                        </div>
                                    ))}
                                </div>
                        }
                    </div>
                </div>
                <Footer margin={true} />
            </Spin>
        </div>
    )
}

const mapStateToProps = store => {
    return { auth: store.auth }
}

export default connect(mapStateToProps)(Shop);